export default "__VITE_ASSET__1fe4c3bb__"